import { MessageCircle } from "lucide-react";
import { useContact } from "../contexts/ContactContext";

export const FloatingWhatsApp = () => {
  const { openGate } = useContact();
  return null;
};
